"use client";
import React, { useEffect, useState } from "react";
import CityFilterWidget from "./components/CitiesBox/cityfilter_widget";
import PopularProjectsWidget from "./components/PopularProjects/Popularprojects_widget";
import NewsContainer from "./components/NewsContainer/NewsContainer";
import ArticlesContainer from "./components/ArticlesContainer/ArticlesContainer";

export default function HomePage() {
  const phrases = [
    ["TEMELDEN", "YATIRIM", "TEMELDEN", "KAZANÇ"],
    ["TEMELDEN", "KONUT", "TEMELDEN", "KAZANÇ"],
    ["TEMELDEN", "ARSA", "TEMELDEN", "KAZANÇ"],
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(1024);

  // 🔸 Ekran boyutunu dinamik olarak takip et
  useEffect(() => {
    const updateWidth = () => setWindowWidth(window.innerWidth);
    setWindowWidth(window.innerWidth); // ilk yüklemede güncelle
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  // 🔸 Yazı animasyonu döngüsü
  useEffect(() => {
    if (document.hidden) return; // sekme görünür değilse boşuna çalışmasın
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % phrases.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [phrases.length]);

  const isMobile = windowWidth <= 768;

  return (
    <div style={styles.page}>
      <div className="hero-container" style={styles.heroContainer}>
        <div className="overlay" style={styles.overlay}>
          <div style={styles.textContainer}>
            <h1
              style={{
                ...styles.title,
                ...(isMobile && styles.mobileTitle),
              }}
            >
              {phrases[currentIndex].map((word, index) => (
                <span
                  key={index}
                  style={{
                    ...styles.word,
                    ...(isMobile && styles.mobileWord),
                    color: index % 2 === 1 ? "#FFC107" : "#ffffff",
                  }}
                >
                  {word}
                </span>
              ))}
            </h1>
          </div>
        </div>
      </div>

      <CityFilterWidget />
      <PopularProjectsWidget />
      <NewsContainer />
      <ArticlesContainer />
    </div>
  );
}

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Poppins', sans-serif",
  },
  heroContainer: {
    width: "100%",
    height: "500px",
    backgroundImage: `url("/images/HomePage/homepage.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
  },
  overlay: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "20px",
  },
  textContainer: {
    textAlign: "center",
  },
  title: {
    fontSize: "42px",
    color: "#ffffff",
    fontWeight: "600",
    margin: 0,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    fontFamily: "'Roboto', sans-serif",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },
  word: {
    display: "inline-block",
    margin: "0 5px",
    transition: "opacity 0.6s ease, transform 0.6s ease",
  },
  mobileTitle: {
    fontSize: "28px",
    flexDirection: "column",
    gap: "4px",
  },
  mobileWord: {
    margin: "2px 0",
    width: "100%",
    textAlign: "center",
  },
};
